<!-- A state, in one word. Factory-owned. Styles in kit.css.

     `tone` is meaning, not decoration: success for done/approved, warning for
     something that needs attention, danger for refused/failed, accent for the
     current/active one, neutral for everything else. Each tone is mixed toward
     the ink for its text, so all five clear WCAG AA on their own ground. -->
<template>
  <span class="kit-pill" :class="`kit-pill--${tone}`">{{ label }}</span>
</template>

<script setup>
defineProps({
  label: { type: String, required: true },
  tone: {
    type: String,
    default: 'neutral',
    validator: (v) => ['neutral', 'accent', 'success', 'warning', 'danger'].includes(v),
  },
});
</script>
